import { Link } from "components/elements";
import { ImgIcon, TableRow, TableRowColumn } from "components/layout";
import { isStatusReleaseStage, RELEASE_STAGES } from "hooks/tivoApps";
import {
  TiVoAppProvider,
  TiVoAppVariant,
  TiVoPublications,
} from "hooks/tivoApps/types";
import {
  DEFAULT_PATHS,
  IMAGES,
  PATHS as TIVO_APPS_PATHS,
} from "pages/TiVoApps/constants";
import { PublicationStatus } from "pages/TiVoApps/PublicationsList";
import { getReleaseStagePublication } from "pages/TiVoApps/PublicationsList/utils";
import { getImageUrlFromAssets } from "pages/TiVoApps/utils";
import { pathToUrl } from "utils/url";

import styles from "./TiVoDeviceAppsList.scss";

interface TiVoDeviceAppRowProps {
  publication: TiVoPublications;
  provider: TiVoAppProvider;
  variant: TiVoAppVariant;
  platformId: string;
  oemId: string;
  clientTypeId?: string;
}

export function TiVoDeviceAppRow({
  provider,
  variant,
  publication,
  platformId,
  oemId,
  clientTypeId,
}: TiVoDeviceAppRowProps) {
  const releaseStagePublication = getReleaseStagePublication(
    publication,
    platformId,
    oemId,
    clientTypeId
  );
  const variantReleaseStages =
    publication.variant?.status.filter(isStatusReleaseStage) || [];
  return (
    <>
      <TableRow>
        <TableRowColumn className={styles.name}>
          <ImgIcon
            src={
              getImageUrlFromAssets(
                provider.assets,
                IMAGES.PRIMARY_BRANDING_LOGO_SQUARE
              ) ||
              getImageUrlFromAssets(
                provider.assets,
                IMAGES.PARTNER_SOURCE_LOGO_SQUARE
              )
            }
            className={styles.icon}
          />
          <Link
            to={pathToUrl(TIVO_APPS_PATHS.detailsProvider, {
              id: provider.id,
              tabId: DEFAULT_PATHS.APP_DETAILS,
            })}
          >
            {provider.label}
          </Link>
        </TableRowColumn>
        <TableRowColumn>
          <Link
            to={pathToUrl(TIVO_APPS_PATHS.detailsVariant, {
              id: provider.id,
              variantId: variant.id,
              tabId: DEFAULT_PATHS.VARIANT_DETAILS,
            })}
          >
            {variant.label}
          </Link>
        </TableRowColumn>
        {RELEASE_STAGES.map((releaseStage) => (
          <TableRowColumn key={releaseStage}>
            <PublicationStatus
              publication={releaseStagePublication}
              releaseStage={releaseStage}
              variantReleaseStages={variantReleaseStages}
            />
          </TableRowColumn>
        ))}
      </TableRow>
    </>
  );
}
